<template>
    <div class="d-flex justify-content-center align-items-center homeScreen-wrapper">
        <div class="homeScreen-inner">
            <div class="appLogo-box"><img :src='StarmateLogo' alt=""></div>
            <h4 class="appName-text">Welcome To Starmate App</h4>
        </div>
    </div>
</template>
<script>
import StarmateLogo from '../assets/images/starmate-logo.webp'
export default {
    name: 'DefaultComponent',
    data () {
        return {
            StarmateLogo: StarmateLogo,
        }
    }
}
</script>